
    import '/vercel/path0/docs/guide/page-tab.$tab-example.md?watch=parent';
    export const toc = [];
export const frontmatter = {"title":"Tab 示例","toc":"menu","filename":"docs/guide/page-tab.$tab-example.md","description":"这里是页面 Tab 的示例，内容在独立的 Markdown 中维护。"};